<template>
  <div>
    <div class="loader" v-if="!chapter">
      בטעינה...
      <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div>
    <div v-if="error">{{ $t("game-new.game-page.error") }}</div>
    <div v-if="error" @click="goBack">{{ $t("game-new.game-page.back") }}</div>
    <div v-if="chapter" class="game-page">
      <GameHeader
        :currentData="data"
        :word="currentWord"
        :trigger="trigger"
        :title="title"
        :progress="progress"
        :total="playedItems"
      />
      <GameSummary
        v-if="isSummary"
        :msg="msg"
        :playedItems="currItems"
        :currentData="data"
        @restartGame="restartGame"
      />
      <div class="word-game-main" v-if="!isSummary">
        <div class="question" v-if="question">
          <AudioBtn
            v-if="question.qWord.id"
            :urlId="question.qWord.id"
            :autoplay="autoPlay"
            :idx="idx"
          />
          <span
            v-if="!question.onlyAudio && question.qWord.Eng"
            class="q"
          >
            {{ question.qWord.Eng }}</span
          >
        </div>
        <ul class="answers grid" v-if="question">
          <li
            v-for="answer of question.answers"
            :key="answer.objectID"
            :class="{
              nope: choosenId && question.qWord.objectID !== answer.objectID,
              rightword:
                choosenId && question.qWord.objectID === answer.objectID,
              damnright:
                choosenId && question.qWord.objectID === answer.objectID,
              wrong:
                choosenId === answer.objectID &&
                question.qWord.objectID !== answer.objectID
            }"
            @click="checkAnswerA(answer, idx)"
          >
            {{ answer.heb }}
          </li>
        </ul>
      </div>
      <div class="actions-wrapper">
        <button v-if="showNext" class="btn-next" @click="nextQuestion">
          {{ $t("game-new.game-page.next_q") }}
        </button>
        <button @click="showSummary" v-if="showResults" class="btnSum">
          {{ $t("game-new.game-page.summery") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import "./game-page.scss";
import { mapGetters } from "vuex";
import GameSummary from "./game-summary.vue";
import GameHeader from "./game-header.vue";
import ProgressBar from "../Shared/progressBar.vue";
import OnBoardingModal from "../onBoardingModal/OnBoardingModal.vue";
import AudioBtn from "../Shared/audioBtn.vue";
import { wordService } from "../../services/wordService";
// import confetti from "canvas-confetti";
import { userService } from "../../services/userService";
import { settingsService } from "../../services/settingsService";
import SlinkyVue from "../Shared/Slinky.vue";
const initializeState = {
  currItems: [],
  chapter: null,
  questions: [],
  question: null,
  WIN: 3,
  LOSS: 0,
  idx: 0,
  showNext: false,
  isClicked: false,
  status: "",
  choosenId: "",
  isSummary: false,
  showResults: false,
  results: [],
  onlyArbT: false,
  msg: "",
  savedWords: [],
  courseData: null,
  currentWord: null,
  trigger: 1,
  autoPlay: true,
  soundsPlay: true,
  soundSetting: [],
  error: false,
  title: null,
  itemsLength: 0,
  AllItems: 0,
  skip: true,
  progress: 0,
};
export default {
  name: "game-new",
  props: ["data", "type"],
  data() {
    return {
      ...initializeState
    };
  },
  computed: {
    ...mapGetters(["words", "chapters", "user"]),
    currentGame() {
      return this.$store.getters.currentGame;
    }
  },
  async mounted() {
    console.log("Game data: ", this.currentGame);
    this.init();
    this.soundSetting = await settingsService.getSettings();
  },
  watch: {
    $route(to, from) {
      this.init();
    },
    currentGame() {
      this.courseData = this.currentGame;
    },
    question() {
      this.currentWord = JSON.parse(JSON.stringify(this.question));
      this.currentWord.qWord.know = this.currentWord.qWord.know
        ? this.currentWord.qWord.know
        : 0;
    },
    currentWord() {
      console.log("CURRENT WORD MAIN CHNAGE");
    },
    user() {
      if (!this.showResults && !this.isSummary) {
        this.init();
      }
    },
    soundSetting() {
      if (this.soundSetting && this.soundSetting.length)
        this.autoPlay = this.soundSetting[1];
      this.soundsPlay = this.soundSetting[0];
    }
  },
  methods: {
    async init() {
      (this.currItems = []),
        (this.chapter = null),
        (this.questions = []),
        (this.idx = 0),
        (this.LOSS = 0),
        (this.showNext = false),
        (this.isClicked = false),
        (this.status = ""),
        (this.choosenId = ""),
        (this.isSummary = false),
        (this.showResults = false),
        (this.results = []);
      this.savedWords = [];
      const { id, gameid } = this.$route.params;

      // console.log("INIT HERE", gameid);
      // console.log(this.$route.query);
      // Game with half score
      if (this.type === "half") {
        if (this.data) {
          let gameWords = await wordService.getGameWords(
            this.data.game.algolia_game_id
          );
          this.WIN = 2;
          console.log(gameWords);
          if (!gameWords) {
            this.error = true;
          }
          console.log(this.words);
          //console.log(this.words.filter(w => w.id === "1774"));
          // this.currItems = await this.words.filter(w =>
          //   gameWords.includes(parseInt(w.id))
          // );
          this.currItems = gameWords;
          // if (gameWords.length == 0) this.$router.push("/chapter");
          if (this.user) {
            this.currItems.forEach(word => {
              const kW = this.user.known_words.find(
                w => w.external_id == word.id
              );
              if (kW) {
                word.know = kW.score || 0;
              }
            });
          }
          //this.currItems.forEach(item => (item.know = 1));
          console.log(this.currItems);
        }
        this.chapter = {
          title: this.$t("game-new.game-page.game"),
          questionsNumber: 10
        };
      }
      // Game with full score
      if (this.type === "full") {
        if (this.data) {
          let gameWords = await wordService.getGameWords(
            this.data.game.algolia_game_id
          );
          this.WIN = 4;
          // this.currItems = await this.words.filter(w =>
          //   gameWords.includes(parseInt(w.id))
          // );
          this.currItems = gameWords;
          if (this.user) {
            this.currItems.forEach(word => {
              const kW = this.user.known_words.find(
                w => w.external_id == word.id
              );
              if (kW) {
                console.log(kW);
                word.know = kW.score || 0;
              }
            });
          }
        }
        this.chapter = {
          title: this.$t("game-new.game-page.game"),
          questionsNumber: 10
        };
      }
      // Game from a dictionary word
      if (gameid === "dicword") {
        let gameWords = [this.$route.query];
        let gameRandomWords = [];
        gameRandomWords = await wordService.getRandomWords(7);
        this.WIN = 4;
        this.currItems = gameWords.concat(gameRandomWords);
        this.chapter = {
          title: this.$t("game-new.game-page.game"),
          questionsNumber: 10
        };
      }
      // Game from a word group
      if (gameid === "group") {
        const groupId = this.$route.query.id;
        let gameWords;
        if (groupId) {
          gameWords = await wordService.getGroupWords(groupId);
        }
        let gameRandomWords = [];
        if (gameWords.length < 4) {
          gameRandomWords = await wordService.getRandomWords(5);
        }

        this.WIN = 4;
        this.currItems = gameWords.concat(gameRandomWords);
        this.title = this.$route.query.name;
        this.chapter = {
          title: this.$t("game-new.game-page.game"),
          questionsNumber: 10
        };
      }
      // Game with saved words
      if (gameid === "savedwords") {
        // if (!this.user.saved_words.length) {
        //   console.log("NO SAVED WORDS...");
        // }
        if (!this.user.saved_words.length) {
          console.log("NO SAVED WORDS");
          this.$router.push("/chapter/saved-words");
        }
        if (this.user && this.user.saved_words.length) {
          let gameWords = await wordService.getSavedWords(this.user);
          let gameRandomWords = [];
          if (this.user.saved_words.length < 4) {
            gameRandomWords = await wordService.getRandomWords(5);
          }
          this.WIN = 4;
          // this.currItems = await this.words.filter(w =>
          //   gameWords.includes(parseInt(w.id))
          // );
          this.currItems = gameWords.concat(gameRandomWords);
        }
        this.title = this.$t("game-new.game-page.saved");
        this.chapter = {
          title: this.$t("game-new.game-page.game"),
          questionsNumber: 10
        };
      }
      // Game with known words without full scores
      if (gameid === "processwords") {
        if (!this.user.known_words.length) {
          console.log("NO KNOWN WORDS");
          this.$router.push("/chapter/saved-words");
        }
        if (this.user && this.user.known_words.length) {
          let gameWords = await wordService.getKnownWords(this.user);
          gameWords = gameWords.filter(res => res.know > 0 && res.know < 4);
          let gameRandomWords = [];
          if (gameWords.length < 4) {
            gameRandomWords = await wordService.getRandomWords(5);
          }
          this.WIN = 4;

          this.currItems = gameWords.concat(gameRandomWords);
        }
        this.title = this.$t("game-new.game-page.process");
        this.chapter = {
          title: this.$t("game-new.game-page.game"),
          questionsNumber: 10
        };
      }
      // Game with known words with full scores
      if (gameid === "fullwords") {
        if (!this.user.known_words.length) {
          console.log("NO KNOWN WORDS");
          this.$router.push("/chapter/saved-words");
        }
        if (this.user && this.user.known_words.length) {
          let gameWords = await wordService.getKnownWords(this.user);
          gameWords = gameWords.filter(res => res.know === 4);
          let gameRandomWords = [];
          if (gameWords.length < 4) {
            gameRandomWords = await wordService.getRandomWords(5);
          }
          this.WIN = 4;

          this.currItems = gameWords.concat(gameRandomWords);
        }
        this.title = this.$t("game-new.game-page.full");
        this.chapter = {
          title: this.$t("game-new.game-page.game"),
          questionsNumber: 10
        };
      }
      if (Object.keys(this.currItems).length) {
        console.log("GOTO", this.currItems);
        console.log(Object.keys(this.currItems).length);
        const items = this.currItems.filter(
          item => item.know < this.WIN || !item.know
        );
        if (!items.length && !this.showResults) {
          console.log("DOING THIS SHIT HERE");
          this.currItems.forEach(item => (item.know = this.WIN - 1));
        }
        this.itemsLength = items.length;
        this.AllItems = items.length;
        this.generateQuestion();
      } else {
        // this.init();
      }
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    playWrongAudio(ev) {
      if (!this.soundsPlay) return;
      let audio = new Audio(require("../../assets/audio/LOSS2.mp3"));
      if (this.LOSS % 2 === 0)
        audio = new Audio(require("../../assets/audio/LOSS1.mp3"));
      audio.play();
      this.LOSS = this.LOSS + 1;
    },
    playRightAudio(num) {
      if (!this.soundsPlay) return;
      const audio = new Audio(
        require("../../assets/audio/VICTORY" + num + ".mp3")
      );
      audio.play();
    },
    onBoardingClose(value) {
      this.generateQuestion();
    },
    generateQuestion(lastWord = "") {
      const { type, grammar, id } = this.$route.params;
      const questions = [];

      let items = id === "savedWords" ? this.savedWords : this.currItems;

      //this.currItems[0].know = 5;
      console.log("AAAAAA", items);
      items = items.filter(
        item =>
          (item.know < this.WIN || !item.know) &&
          item.objectID !== lastWord.objectID
      );
      if (items.length < 1) {
        items = id === "savedWords" ? this.savedWords : this.currItems;
        items = items.filter(item => item.objectID !== lastWord.objectID);
      }
      // console.log(items);
      // if (!items.length) {
      //   items = this.currItems;
      // }
      console.log("CCC", items);
      const question = {
        qWord: this.getRandomWord(items, true),
        answers: [],
        // onlyAudio: Math.random() > 0.5 ? true : false
        onlyAudio: false
      };

      let answers = this.generateAnswer("aaa", "type", question.qWord);
      //remove the used word from items array

      answers = this.randomList(answers);
      question.answers = answers;
      questions.push(question);

      console.log(questions);

      this.questions = questions;
      this.question = question;
      this.playedItems = questions.map(q => q.qWord);
    },

    removeWord(word, items) {
      const newItems = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i] != word) {
          newItems.push(items[i]);
        }
      }
      return newItems;
    },
    getRandomWord(items = this.currItems, isQuestion = false, limit = 12) {
      const randomNumber = Math.floor(Math.random() * items.length);

      const ranWord = items[randomNumber];
      if (ranWord) {
        if (ranWord.know >= 5 && isQuestion && limit > 0) {
          return this.getRandomWord(items, isQuestion, limit - 1);
        } else {
          return ranWord;
        }
      }
    },
    generateAnswer(family, kind, rightAnswer) {
      console.log(rightAnswer);
      const filteredWords = this.currItems.filter(i => i.id !== rightAnswer.id);
      console.log(filteredWords);
      console.log(rightAnswer);
      const answers = [rightAnswer];
      let limit = 30;
      let max = filteredWords.length <= 3 ? filteredWords.length - 1 : 3;
      for (let i = 0; i < max; i++) {
        const randomAnswer = this.getRandomWord(filteredWords, false, limit);
        const ids = answers.map(a => a.objectID);
        ids.includes(randomAnswer.objectID) && max < limit
          ? max++
          : answers.push(randomAnswer);
      }
      console.log(answers);

      return answers;
    },
    async checkAnswerA(answer) {
      const { id, type, grammar } = this.$route.params;
      if (this.isClicked) return;
      this.isClicked = true;
      this.choosenId = answer.objectID;
      if (answer.heb === this.question.qWord.heb) {
        this.status = "right";
        console.log("currentWord", this.currentWord);
        if (this.currentWord.qWord.know < 4)
          this.currentWord.qWord.know = this.currentWord.qWord.know + 1;
        this.currentWord = JSON.parse(JSON.stringify(this.currentWord));
        this.trigger++;

        //this.playedItems[this.idx].isRight = true;
        const newidx = this.currItems.findIndex(
          element => element.objectID === answer.objectID
        );
        this.currItems[newidx].know = this.currItems[newidx].know
          ? this.currItems[newidx].know + 1
          : 1;
        if (this.currItems[newidx].know > 4) this.currItems[newidx].know = 4;
        console.log("RIGHT!", this.currItems[newidx].know);
        this.playRightAudio(this.currItems[newidx].know);
      } else {
        this.status = "wrong";
        this.playWrongAudio();
        this.currentWord.qWord.know = this.currentWord.qWord.know
          ? this.currentWord.qWord.know - 1
          : 0;
        this.currentWord = JSON.parse(JSON.stringify(this.currentWord));
        //this.playedItems[this.idx].isRight = false;
        const newidx = this.currItems.findIndex(
          element => element.objectID === this.question.qWord.objectID
        );
        this.currItems[newidx].know = this.currItems[newidx].know
          ? this.currItems[newidx].know - 1
          : 0;
        this.currItems[newidx].wrong = this.currItems[newidx].wrong
          ? this.currItems[newidx].wrong + 1
          : 1;
        console.log("WRONG!", this.currItems[newidx].know);
      }
      const items = this.currItems.filter(
        item => item.know < this.WIN || !item.know
      );
      this.itemsLength = items.length;
      console.log("ITEMS", items);
      if (items.length && this.skip) {
        // if (this.status == "right") {
        //   setTimeout(() => this.nextQuestion(), 500);
        // }
        this.showNext = true;
      } else {
        // confetti({
        //   particleCount: 50,
        //   spread: 70,
        //   origin: { y: 0.6 },
        //   ticks: 200
        // });
        this.showResults = true;
        const known_words = this.currItems
          .map(word => {
            return { external_id: word.id, score: word.know };
          })
          .filter(res => res.external_id);
        console.log(known_words);

        if (this.data) await userService.finishLesson(this.data.id, this.user);
        if (this.user) await userService.updateWords(known_words);
      }
      // if (this.idx + 1 == this.chapter.questionsNumber) {
      //   this.showResults = true;
      // }
    },
    nextQuestion() {
      this.choosenId = null;
      this.isClicked = false;
      this.idx++;
      this.showNext = false;
      // this.question.qWord.id = null;
      console.log("BBBB", this.question.qWord);
      this.generateQuestion(this.question.qWord);
    },
    randomList(answers) {
      return answers.sort(() => {
        return 0.5 - Math.random();
      });
    },
    goBack() {
      this.$router.push("/chapter");
    },
    showSummary() {
      const { id, type, grammar } = this.$route.params;
      this.progress = 0;
      const items = this.playedItems;
      items.forEach(item => {
        if (item.isRight) {
          this.progress += 1;
        }
      });
      this.progress = (this.progress / this.playedItems.length) * 100;
      const rightItems = this.playedItems.filter(i => i.isRight);
      (this.isSummary = true), (this.showResults = false);
      this.msg = this.$t("game-new.game-page.welldone");
      if (!this.user) return;
    },
    restartGame() {
      this.init();
    }
  },
  components: {
    ProgressBar,
    AudioBtn,
    GameSummary,
    GameHeader,
    OnBoardingModal,
    SlinkyVue
  }
};
</script>

<style scoped>
.loader {
  text-align: center;
  margin: 30px;
}

button {
  border: none;
}

.theword {
  position: absolute;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// game-page.vue?2df5ae83